var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cadastro-simples-form',{attrs:{"endpoint":"almox-grupo","rota-base":"/admin/almox-grupo","titulo-singular":"Grupo"}})
}
var staticRenderFns = []

export { render, staticRenderFns }